import React, { useState, useEffect } from "react";
import { getRequest, postRequest } from "../../../../../../services/api/apiService";
import { toast } from "react-toastify";
// import {
//   Select,
//   SelectTrigger,
//   SelectValue,
//   SelectContent,
//   SelectItem,
// } from "@/components/ui/select";

const ConnectedPlatformAccountGoogleConfigurationModal = ({
  platformName,
  headers,
  onClose,
  handleFetchConnectedPlatforms,
}) => {
  // const [mamnagerAccountIdOptions, setManagerAccountIdOptions] = useState([]);
  const [googleAdsIdOptions, setGoogleAdsIdOptions] = useState([]);
  // const [selectedManagerAccountIdOption, setSelectedManagerAccountIdOption] =
  //   useState("");
  const [selectedGoogleAdsIdOption, setSelectedGoogleAdsIdOption] =
    useState("");
  const [isSaving, setIsSaving] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    // Simulate API calls to fetch dropdown options

    const fetchSelectedData = async () => {
      try {
        const response = await getRequest(
          "/api/ads/google/fetch-google-ads-account",
          { ...headers }
        )

        console.log("fetchSelectedData resp.: ", response);

        const responseData = response.data;

        if(responseData && responseData['google_ads_id']) {
          setSelectedGoogleAdsIdOption(responseData['google_ads_id'])
        }

      } catch (err) {
        console.error("Error fetching selected data", err);
        setError("Failed to fetch selected data or does not exist.");
      }
    };

    const fetchDropdownOptions = async () => {
      try {
        const response = await getRequest(
          "/api/ads/google/fetch-accessible-ads-accounts",
          { ...headers }
        ).catch((err) => {
          console.error(err);
        });

        console.log("fetchDropdownOptions resp.: ", response);

        if (!response || !response.data) {
          return;
        }

        setGoogleAdsIdOptions(response.data)

      } catch (err) {
        console.error("Error fetching dropdown options", err);
        setError("Failed to fetch dropdown options.");
      }
    };

    fetchSelectedData()
    fetchDropdownOptions();
  }, []);

  const saveGoogleAccounts = async () => {
    // Check if all fields are filled
    if (!googleAdsIdOptions) {
      setError("All fields are required!");
      return;
    }

    try {
      setIsSaving(true);
      setError(null);

      await postRequest(
        "/api/ads/google/save-google-ads-account",
        {
          googleAdsId: selectedGoogleAdsIdOption,
        },
        { ...headers }
      );

      toast.success("Google Access Token updated successfully!");
      onClose();
      handleFetchConnectedPlatforms();
    } catch (err) {
      console.error(err);
      setError("An error occurred while saving the access token for Google.");
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <div className="p-4 w-full max-w-lg mx-auto space-y-6 bg-white rounded-lg shadow-lg">
      
      <div className="space-y-4">

        {/* <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Manager Account ID
          </label>
          <select
            value={selectedManagerAccountIdOption}
            onChange={(e) => setSelectedManagerAccountIdOption(e.target.value)}
            className="mt-1 p-2 w-full border rounded-lg focus:ring-2 focus:ring-blue-500 focus:outline-none z-10" 
          >
            <option value="" disabled>
              Select an option for Manager Account ID
            </option>
            {mamnagerAccountIdOptions.map((option) => (
              <option key={option.id} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        </div> */}

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Google Ads ID
          </label>
          <select
            value={selectedGoogleAdsIdOption}
            onChange={(e) => setSelectedGoogleAdsIdOption(e.target.value)}
            className="mt-1 p-2 w-full border rounded-lg focus:ring-2 focus:ring-blue-500 focus:outline-none z-10" 
          >
            <option value="" disabled>
              Select an option for GoogleAdsId
            </option>
            {googleAdsIdOptions.map((option) => (
              <option key={option.id} value={option.id}>
                {`${option.id} (${option.name}) ${option.manager? " Manager" : ""}`}
              </option>
            ))}
          </select>
        </div>
      </div>

      {/* Note/Disclaimer */}
      <div className="text-xs text-gray-500 italic mb-6">
        The ID of your Google Ads account
      </div>

      {/* Error Message */}
      {error && <div className="text-red-500 text-sm mb-4">{error}</div>}

      {/* Buttons */}
      <div className="flex justify-end gap-4">
        <button
          onClick={onClose}
          className="px-4 py-2 bg-gray-200 text-gray-800 rounded-lg hover:bg-gray-300"
        >
          Cancel
        </button>
        <button
          onClick={saveGoogleAccounts}
          disabled={
            isSaving ||
            // !selectedManagerAccountIdOption ||
            !selectedGoogleAdsIdOption
          }
          className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:bg-gray-400"
        >
          {isSaving ? "Saving..." : "Save"}
        </button>
      </div>
    </div>
  );
};

export default ConnectedPlatformAccountGoogleConfigurationModal;
